import { Message as UikitMessage } from "@sendbird/uikit-react/GroupChannel/components/Message";
import UikitMessageContent from "@sendbird/uikit-react/ui/MessageContent";
import type { MessageContentProps } from "@sendbird/uikit-react/ui/MessageContent";
import { MobileBottomSheet } from "@sendbird/uikit-react/ui/MobileMenu";

type GroupChannelMessageProps = Parameters<typeof UikitMessage>[0];

// render sendbird's stock MessageContent/MobileBottomSheet, but with one major difference:
// removing the list of action items (Copy/Edit/Reply/Delete) from the bottom sheet
const renderMessageContent = (props: MessageContentProps) => (
  <UikitMessageContent
    // eslint-disable-next-line react/jsx-props-no-spreading -- forwarding uikit-react's renderMessageContent params
    {...props}
    renderMobileMenuOnLongPress={(menuProps) => (
      <MobileBottomSheet
        // eslint-disable-next-line react/jsx-props-no-spreading -- forwarding uikit-react's renderMobileMenuOnLongPress params
        {...menuProps}
        // an empty fragment here is necessary, as returning null will cause sendbird to fallback to its stock menu (WITH Copy/Edit/Reply/Delete)
        // eslint-disable-next-line react/jsx-no-useless-fragment
        renderMenuItems={() => <></>}
      />
    )}
  />
);

const GroupChannelMessage = (props: GroupChannelMessageProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading -- forwarding uikit-react's renderMessage params
  <UikitMessage {...props} renderMessageContent={renderMessageContent} />
);

export default GroupChannelMessage;
